import jquery from "jquery";
let careersClass = 'c-careers';

var initializeAccordion = function($block, $attributes) {
	let elem = $block;
	if (!$block.hasClass(careersClass)) {
		elem = $block.find("." + careersClass);
	}

	$('.c-careers__type__title').on('click',function(){
		$(this).toggleClass('active');
		$(this).siblings().slideToggle();
	});
};

// Initialize each block on page load (front end).
$(document).ready(function($) {
	$("." + careersClass).each(function() {
		initializeAccordion($(this), false);
	});
});